export const PAGE_SIZE: number = 48;
export const AGGREGATE_PAGE_SIZE: number = 20;
export const MAX_SCOUT_FILTER_SIZE: number = 500;